import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import {
  getInvoiceItem,
  getServices,
  getSpecificInvoice,
} from "../../actions/invoiceItem";
import { getInvoiceMeasurement } from "../../actions/measurment";
import { getBusinessProfile } from "../../actions/settings";
import { getSpecificLocation } from "../../actions/warehouseAction";
import Barcode from "react-barcode";

import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Space,
  Divider,
  Drawer,
  Image,
  Skeleton,
} from "antd";
import { result } from "lodash";
import moment from "moment";

const { Option } = Select;

const Quickview = ({
  id,
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  businessprofile,
  getInvoiceMeasurement,
  getSpecificInvoice,
  getSpecificLocation,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const officeCopyRef = useRef();
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(true);
  const [branch, setbranch] = useState([]);
  const [data, setdata] = useState([]);
  const [details, setdetails] = useState([]);
  const [measurements, setmeasurements] = useState([]);
  const [services, setservices] = useState([]);
  const [printMode, setPrintMode] = useState("customer");
  const count = useRef(0);
  const serialcount = useRef(0);
  const formattedCreatedDate = moment(details.created_at).format("YYYY-MM-DD HH:mm:ss");

  const subtotal = parseFloat(details.additional_discount) + parseFloat(details.spec_item_discount) + parseFloat(details.discount) + parseFloat(details.bill);

  useEffect(() => {
    getSpecificInvoice(id).then((result) => {
      setdetails(result);
      console.log(result);
      getSpecificLocation(result.location).then((r) => {
        setbranch(r);
      });
    });
    getInvoiceItem(id).then((e) => {
      getBusinessProfile();
      getServices(id).then((service) => {
        getInvoiceMeasurement(id).then((result) => {
          if (result.length > 0) {
            setmeasurements(result[0]);
          } else {
            setmeasurements(false);
          }
          console.log(measurements);
          count.current = e.length + service.length;
          if (count.current < 10) count.current = 10 - count.current;
          else {
            count.current = 0;
          }
          setdata([...e, ...service]);

          setloading(false);
          setservices(service);

          // Auto Print after POS submit
          setTimeout(function () {
            document.getElementById("yo-print").click();
          }.bind(this), 500)
        });
      });
    });
  }, []);

  // FOR AUTO PRINT IN ENTER
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        // if (printMode === 'customer') {
        //   document.getElementById("yo-print").click();
        // } else {
        document.getElementById("office-print").click();
        // }
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [printMode]);

  const printAction = () => {
    if (componentRef.current) {
      ReactToPrint.print(componentRef.current);
    }
  };

  const printOfficeCopy = () => {
    if (officeCopyRef.current) {
      ReactToPrint.print(officeCopyRef.current);
    }
  };

  const onClose = () => {
    setVisible(false);
  };

  const renderImage = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <img
          src={branch.logo}
          style={{
            width: "40%",
            right: "0",
          }}
        />
      );
    }
  };

  const renderitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return data.map((item, index) => {
        serialcount.current = index + 1;
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              {item.details ? (
                <td>
                  {" "}
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{ __html: item.details }}
                  ></div>
                </td>
              ) : (
                <td> {item.Details}</td>
              )}
              <td>{formatter.format(item.price)}</td>
              <td style={{ textAlign: "center", margin: "auto" }}>
                {item.quantity}
              </td>
              <td style={{ textAlign: "center", margin: "auto" }}>
                {item.spec_discount}
              </td>
              <td
                style={{
                  textAlign: "center",
                  margin: "auto",
                  paddingRight: "5px",
                }}
              >
                {formatter.format(item.price * item.quantity - item.spec_discount)}
              </td>
            </tr>
          </>
        );
      });
    }
  };

  const renderblanktables = () => {
    if (loading) {
      return "";
    } else {
      let indexcount = 0;
      return Array.apply(null, Array(count.current)).map(() => {
        indexcount = indexcount + 1;
        return (
          <tr>
            <td>{serialcount.current + indexcount}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        );
      });
    }
  };

  if (loading) {
    return <Skeleton active />;
  } else {
    return (
      <>
        <div style={{ marginBottom: '10px' }}>
          <ReactToPrint
            trigger={() => <button id="yo-print">Print Customer Copy</button>}
            content={() => componentRef.current}
            onBeforeGetContent={() => setPrintMode('customer')}
          />
          <ReactToPrint
            trigger={() => <button id="office-print" style={{ marginLeft: '10px' }}>Print Office Copy</button>}
            content={() => officeCopyRef.current}
            onBeforeGetContent={() => setPrintMode('office')}
          />
        </div>

        {/* Customer Copy */}
        <div style={{ display: "block" }}>
          <div ref={componentRef} style={{ padding: "10px" }}>
            <Row
              className="invoice_print_fontSize"
              style={{
                marginTop: "2px",
                paddingBottom: "2px",
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                {details.Location_name === "Main Warehouse" ? (
                  <Row>
                    <Col span={8} style={{ textAlign: "left" }}>
                      <div style={{
                        // transform: "scale(1.5)", 
                        transformOrigin: "right",
                        width: "fit-content",
                        height: "fit-content",
                        position: "absolute",
                        // left: "0px",
                        top: "100%",
                        right: "30px",
                        transform: "scale(1) translateY(-50%)"
                      }}>
                        {renderImage()}
                      </div>
                    </Col>
                    <Col span={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <div style={{ fontWeight: "800", fontSize: "44px", letterSpacing: "5px", fontFamily: '"Times New Roman", Times, serif', }}>
                        SHIRTEX
                      </div>
                    </Col>
                    <Col span={8}>

                    </Col>
                  </Row>
                ) : (
                  renderImage()
                )}
                <div
                  className="d-div"
                  dangerouslySetInnerHTML={{ __html: details.Location[0].address }}
                ></div>
                <div
                  className="d-div"
                  dangerouslySetInnerHTML={{ __html: businessprofile.social_link }}
                ></div>
                Showroom: <>{details.Location[0].contact}</>{" "}
                <div
                  style={{
                    borderWidth: 2,
                    borderStyle: "solid",
                    borderColor: "#303338",
                    marginBottom: "5px",
                  }}
                ></div>
              </Col>
              <Col span={24} style={{ marginTop: "10px" }}>
                MUSHAK 6.3<br></br>
                INVOICE N0.{" "}
                {details.invoice_number ? (
                  <>{details.invoice_number}</>
                ) : (
                  ""
                )}{" "}
                <br></br>
                {details.created_at ? (
                  <>
                    ISSUE DATE : {formattedCreatedDate}
                    <br></br>
                  </>
                ) : (
                  ""
                )}
              </Col>
              {details.contact ? (
                <>
                  <Row>
                    <Col span={24}>
                      {details.Contact[0].name ? (
                        <>CUSTOMER NAME : {details.Contact[0].name}<br></br></>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col span={24}>
                      {details.Contact[0].phone ? (
                        <>CUSTOMER CONTACT : {details.Contact[0].phone}<br></br></>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      {details.Contact[0].address ? (
                        <>ADDRESS : {details.Contact[0].address}<br></br></>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
            </Row>
            <br></br>
            <Row>
              <Col span={24}>
                <table className="product_table invoice_print_fontSize">
                  <tbody>
                    <tr style={{ fontWeight: "500", border: "2px" }}>
                      <td>SL</td>
                      <td>Details</td>
                      <td>M.R.P</td>
                      <td>Qty</td>
                      <td>Disc</td>
                      <td style={{ textAlign: "center" }}>TOTAL</td>
                    </tr>
                    {renderitems()}
                  </tbody>
                </table>

                <Row>
                  <Col
                    span={11}
                    style={{ textAlign: "left", marginTop: "20px", }}
                  >
                    <Row>
                      <Col span={24} style={{ margin: "auto", fontSize: "20px" }}>
                        Method: {details.Payment_method}
                      </Col>
                    </Row>

                    {details.remarks ? (
                      <>
                        <Row>
                          <Col span={24} style={{ margin: "auto", fontSize: "20px" }}>
                            Remarks:
                            <div className="d-div-invoice"
                              style={{
                                fontWeight: '800',
                                fontSize: '24px',
                                color: "red"
                              }}
                              dangerouslySetInnerHTML={{ __html: details.remarks, }}
                            >
                            </div>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col
                    span={12}
                    className="invoice_print_fontSize"
                    style={{
                      textAlign: "right",
                      marginTop: "20px",
                    }}
                  >
                    {details.Location_name === "Main Warehouse" ? (
                      null
                    ) : (
                      <>
                        {details.tax > 0 ? (
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              VAT (Inclusive)
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.tax)}
                              </span>
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    {details.delivery_charge > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Delivery Cost(+)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.delivery_charge)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        M.R.P Sub Total
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">{formatter.format(subtotal)}</span>
                      </Col>
                    </Row>

                    {details.additional_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Additional Disc(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.additional_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    {details.spec_item_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Product Disc(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.spec_item_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    {details.discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Sales Disc(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    {details.Location_name != "Main Warehouse" ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Total Amount
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.bill)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    {details.Location_name == "Main Warehouse" ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Advance
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.receive)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    {/* {details.Location_name != "Main Warehouse" && details.due > 0 ? (
                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Receive
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.receive)}
                        </span>
                      </Col>
                    </Row>
                    ) : (
                    ""
                  )} */}
                    {details.due >= 0 ? (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          Due
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.due)}
                          </span>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    {details.refund > 0 ? (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          Change
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.refund)}
                          </span>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <br></br>
            <br></br>
            {/* <h4 style={{ fontWeight: '800', fontSize: '22px' }}>TERMS & CONDITIONS:</h4>
            <small>
                <div style={{ 
                  fontWeight: '800', 
                  marginBottom: "10px", 
                  fontSize: '20px',
                  marginLeft: "20px"
                }}
                  className="d-div" 
                  dangerouslySetInnerHTML={{
                    __html: businessprofile.invoice_terms,
                  }}
                ></div>
              </small> */}
              
            <h4 style={{ fontWeight: 'bold', fontSize: '22px', color: '#000' }}><u>TERMS & CONDITIONS:</u></h4>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ fontWeight: 'bold', fontSize: "20px", color: '#000' }}>1. Product can be exchanged once within 3 days in intact condition</li>
              <li style={{ fontWeight: 'bold', fontSize: "20px", color: '#000' }}>2. Under Any Circumstances, No Amount will Be Refunded</li>
              <li style={{ fontWeight: 'bold', fontSize: "20px", color: '#000' }}>3. Invoice must be brought for exchanging product</li>
            </ul>
            {details.Location_name === "Main Warehouse" ? (
              null
            ) : (
              <Row style={{ margin: "auto" }}>
                <Col span={16}>
                  <Barcode value={details.invoice_number} width={3} height={55} format="CODE128" />
                </Col>
                <Col span={2}></Col>
                <Col span={2}></Col>
              </Row>
            )}

            <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338' }}></div>
            <span className="invoice_print_fontSize">
              <div style={{ fontWeight: '700', fontSize: "20px", marginTop: "10px", }}>Powered by: THE ICT HUB</div>
              <div style={{ fontWeight: '700', fontSize: "18px", marginBottom: "10px" }}>Visit: https://theicthub.com</div>
            </span>
          </div>
        </div>

        {/* Office Copy - Simplified Version */}
        <div style={{ display: "none" }}>
          <div ref={officeCopyRef} style={{ padding: "10px" }}>
            <Row
              className="invoice_print_fontSize"
              style={{
                marginTop: "2px",
                paddingBottom: "2px",
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                {/* {renderImage()} */}
                <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginBottom: "5px" }}></div>
              </Col>
              <Col span={24} style={{ marginTop: "10px" }}>
                INVOICE N0. {details.invoice_number || ""}<br></br>
                DATE: {formattedCreatedDate || ""}<br></br>
              </Col>
              {details.contact ? (
                <>
                  <Row>
                    <Col span={24}>
                      CONTACT: {details.Contact[0].phone || ""}
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
            </Row>
            <br></br>
            <Row>
              <Col span={24}>
                <table className="product_table invoice_print_fontSize">
                  <tbody>
                    <tr style={{ fontWeight: "500", border: "2px" }}>
                      <td>SL</td>
                      <td>Details</td>
                      <td>Qty</td>
                      <td>Amount</td>
                    </tr>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {item.details ? (
                            <div className="d-div" dangerouslySetInnerHTML={{ __html: item.details }}></div>
                          ) : (
                            item.Details
                          )}
                        </td>
                        <td style={{ textAlign: "center" }}>{item.quantity}</td>
                        <td style={{ textAlign: "center" }}>
                          {formatter.format(item.price * item.quantity - item.spec_discount)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <Row>
                  <Col span={10} className="invoice_print_fontSize" style={{ textAlign: "left", marginTop: "20px" }}>
                    {details.due > 0 && (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          Received
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.receive)}
                          </span>
                        </Col>
                      </Row>
                    )}

                    {details.due > 0 && (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          Due
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.due)}
                          </span>
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col span={12} className="invoice_print_fontSize" style={{ textAlign: "right", marginTop: "20px", marginRight: "10px" }}>
                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Sub Total
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">{formatter.format(subtotal)}</span>
                      </Col>
                    </Row>

                    {details.discount > 0 && (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          Discount
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.discount)}
                          </span>
                        </Col>
                      </Row>
                    )}

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Total
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.bill)}
                        </span>
                      </Col>
                    </Row>

                    {/* <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Received
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.receive)}
                        </span>
                      </Col>
                    </Row>

                    {details.due > 0 && (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          Due
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.due)}
                          </span>
                        </Col>
                      </Row>
                    )} */}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ margin: "auto", textAlign: "center", marginTop: "20px" }}>
              <Col span={24}><Barcode value={details.invoice_number} width={2} height={40} format="CODE128" /></Col>
            </Row>
            <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginTop: "10px" }}></div>
            <div style={{ textAlign: "center", marginTop: "5px", fontSize: "12px" }}>
              Office Copy - {businessprofile.business_name}
            </div>
          </div>
        </div>
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  getInvoiceMeasurement,
  getSpecificInvoice,
  getSpecificLocation,
})(Quickview);